import Navbar from './Navbar';

/**
 * Navbar configuration based on routes
 * Each route can specify:
 * - navbar: Component to render as navbar (or null to hide)
 * - navbarProps: Props to pass to navbar component
 */

/**
 * Get the route pattern from a pathname
 * Converts /projectDetails/123/characters to /projectDetails/:projectId/characters
 */
export const getRoutePattern = (pathname) => {
  // Replace project IDs with :projectId
  let pattern = pathname.replace(/\/projectDetails\/[^/]+/g, '/projectDetails/:projectId');

  // Replace corkboard IDs with :corkboardId
  pattern = pattern.replace(/\/corkboards\/[^/]+/g, '/corkboards/:corkboardId');

  // Replace timeline IDs with :timelineId
  pattern = pattern.replace(/\/timelines\/[^/]+/g, '/timelines/:timelineId');

  return pattern;
};

/**
 * Match a pathname against a route pattern
 */
export const matchRoute = (pathname, pattern) => {
  const routePattern = getRoutePattern(pathname);

  // Exact match
  if (routePattern === pattern) {
    return true;
  }

  // Pattern matching (for more complex matching if needed)
  // Escape special regex characters and replace :param with [^/]+
  const escapedPattern = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/:[^/]+/g, '[^/]+');
  const patternRegex = new RegExp(`^${escapedPattern}$`);
  return patternRegex.test(routePattern);
};

/**
 * Helper function to create navbar props
 * All pages use the same navbar by default
 */
const createNavbarProps = () => ({});

/**
 * Navbar configuration map
 * Keys are route patterns, values are configuration objects
 * All routes use the same navbar by default
 */
export const navbarConfig = {
  // Landing page
  '/': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },

  // Dashboard
  '/dashboard': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },

  // Privacy policy
  '/privacy': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },

  // Settings
  '/settings': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },

  // Default manuscript route
  '/projectDetails/:projectId': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },

  // Characters route
  '/projectDetails/:projectId/characters': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },

  // Notes routes
  '/projectDetails/:projectId/notes': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },

  // Corkboards list
  '/projectDetails/:projectId/notes/corkboards': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },

  // Corkboard editor
  '/projectDetails/:projectId/notes/corkboards/:corkboardId': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },

  // Timelines list
  '/projectDetails/:projectId/notes/timelines': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },

  // Timeline editor
  '/projectDetails/:projectId/notes/timelines/:timelineId': {
    navbar: Navbar,
    navbarProps: createNavbarProps,
  },
};

/**
 * Get navbar configuration for a given pathname
 * Returns the most specific matching route configuration
 */
export const getNavbarConfig = (pathname) => {
  const routePattern = getRoutePattern(pathname);

  // Try exact match first
  if (navbarConfig[routePattern]) {
    return navbarConfig[routePattern];
  }

  // Try to find the most specific matching route
  // Sort by specificity (longer patterns first)
  const patterns = Object.keys(navbarConfig).sort((a, b) => b.length - a.length);

  const matchingPattern = patterns.find((pattern) => matchRoute(pathname, pattern));
  if (matchingPattern) {
    return navbarConfig[matchingPattern];
  }

  // Default to landing page navbar
  return navbarConfig['/'];
};
